uniform float time;
uniform float uDistort;
uniform float uGlow;

varying float pulse;
varying vec2 vUv;
varying vec3 vNormal;

float bandNoise(vec3 dir, float speed, float scale) {
  float phase = dot(dir, vec3(2.4, 3.6, 1.8)) * scale + time * speed;
  float harmonic = sin(phase);
  return harmonic * 0.7 + sin(phase * 0.5) * 0.3;
}

void main() {
  vUv = uv;
  vec3 worldNormal = normalize(normalMatrix * normal);
  vNormal = worldNormal;

  float wave = sin((uv.y + time * 0.1) * 8.0);
  float swirl = sin((uv.x + time * 0.15) * 6.0);
  float pulsate = sin(time * 0.8);

  float envelope = mix(0.1, 0.4, uDistort);
  float displacement = wave * envelope + swirl * 0.15 * uDistort + pulsate * 0.05 * uGlow;

  vec3 animatedPosition = position + normal * displacement;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(animatedPosition, 1.0);
  pulse = mix(0.25, 1.0, clamp(wave * 0.5 + 0.5 + uGlow * 0.3, 0.0, 1.2));
}